export const BiddingScheme = {
  properties: {
    Type: {
      'bulk-upload-header': 'Bid Strategy Type',
    },
    ManualCpi: {
      'bulk-upload-header': 'Bid Strategy ManualCpi',
    },
    ManualCpc: {
      'bulk-upload-header': 'Bid Strategy ManualCpc',
    },
    MaxCpc: {
      'bulk-upload-header': 'Bid Strategy MaxCpc',
      'bulk-upload-mapper': function (value) {
        return value ? value.Amount : undefined;
      },
    },
    MaxCpm: {
      'bulk-upload-header': 'Bid Strategy MaxCpm',
      'bulk-upload-mapper': function (value) {
        return value ? value.Amount : undefined;
      },
    },
    TargetCpa: {
      'bulk-upload-header': 'Bid Strategy TargetCpa',
    },
    TargetRoas: {
      'bulk-upload-header': 'Bid Strategy TargetRoas',
    },
    TargetAdPosition: {
      'bulk-upload-header': 'Bid Strategy TargetAdPosition',
    },
    TargetImpressionShare: {
      'bulk-upload-header': 'Bid Strategy TargetImpressionShare',
    },
    BidStrategyId: {
      'bulk-upload-header': 'Bid Strategy Id',
    },
    BidStrategyScope: {
      'bulk-upload-header': 'Bid Strategy Scope',
    },
    CostPerSale: {
      'bulk-upload-header': 'Bid Strategy TargetCostPerSale',
    },
    PercentMaxCpc: {
      'bulk-upload-header': 'Bid Strategy PercentMaxCpc',
    },
    CommissionRate: {
      'bulk-upload-header': 'Bid Strategy CommissionRate',
    },
  },
};
